import api from "@/config/api.js"

export default {
  'dateFormat': function (timestamp, format) {


    if (!timestamp) {
      return null;
    }

    if (timestamp instanceof Date) {
      timestamp = timestamp.getTime();
    }

    Date.prototype.format = function (fmt) { //author: meizz
      var o = {
        "M+": this.getMonth() + 1,                 //月份
        "d+": this.getDate(),                    //日
        "h+": this.getHours(),                   //小时
        "m+": this.getMinutes(),                 //分
        "s+": this.getSeconds(),                 //秒
        "q+": Math.floor((this.getMonth() + 3) / 3), //季度
        "S": this.getMilliseconds()             //毫秒
      };
      if (/(y+)/.test(fmt))
        fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
      for (var k in o)
        if (new RegExp("(" + k + ")").test(fmt))
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      return fmt;
    };
    return new Date(parseInt(timestamp)).format(format);
  },

  'filterImg': function (code) {
    return api.file.download + '?fileCode=' + code;
  },
  'filterSize': function (size) {
    if (size) {
      size = size / 1024;
      console.log('size', size)
      return (size / 1024).toFixed(2) + 'm';
    }
    return '0m';
  },
  recipeType(type, vm) {
    const typeMap = {
      SOUP: vm.$t('lang.汤机'),
      AIR_FRYER: vm.$t('lang.空炸'),
      SOUP_AND_AIR: vm.$t('lang.汤机+空炸'),
      STAND_MIXER: vm.$t('lang.厨师机'),
      SOUP_AND_STAND_MIXER: vm.$t('lang.汤机+厨师机'),
      OVEN: vm.$t('lang.烤箱'),
    }
    return typeMap[type] || vm.$t('lang.汤机');
  }

}


